export default __webpack_public_path__ + "media/zurb/img/legacy/spur/zoom-d9c965123287b882832e5bfb496d7ae7.jpg";